/** Pour les identifiants de logs spécifiques à une lib ou une app, mettre le préfixe adéquat à la place de `calao`. */
export enum ELogActionId {
	/** Identifiant de l'action pour le démarrage de l'application. */
	appStart = "calao-app-start",
	/** Identifiant de l'action pour la détection d'une nouvelle mise à jour. */
	appUpdateAvailable = "calao-app-update-available",
	/** Identifiant de l'action pour l'installation d'une nouvelle mise à jour. */
	appUpdateStart = "calao-app-update-start",
	/** Identifiant de l'action quand la nouvelle mise à jour a été instalée. */
	appUpdateComplete = "calao-app-update-complete",
	/** Identifiant de l'action qui indique que le contenu de l'application est disponible. */
	appAvailable = "calao-app-available",
	/** Identifiant de la lib calao pour la connexion. */
	login = "calao-auth-login",
	/** Identifiant de la lib calao pour la déconnexion. */
	logout = "calao-auth-logout",
	/** Identifiant de la lib calao pour un échec d'authentification. */
	authenticationFailed = "calao-authentication-failed",
	/** Identifiant de l'action de sauvegarde d'un document sur le serveur. */
	dmsDocUpload = "calao-dms-doc-upload",
	/** Identifiant de la sauvegarde d'un document (serveur ou local). */
	dmsDocSave = "calao-dms-doc-save",
	/** L'envoi d'un document a été annulé. */
	dmsDocUploadCancelled = "dms-doc-upload-cancelled",
	/** Identifiant de la sauvegarde d'un document du store. */
	storeDocSave = "calao-store-doc-save",
	/** Identifiant de la suppression d'un document du store. */
	storeDocDelete = "calao-store-doc-delete",
	/** Identifiant de la sauvegarde de plusieurs documents du store. */
	storeDocsBulk = "calao-store-doc-bulk",
	/** Identifiant de la réplication. */
	storeReplicate = "calao-store-replicate",
	/** Identifiant de l'initialisation d'une base de données. */
	storeInitDb = "calao-store-init-database",
	/** Identifiant de la réinitialisation d'une base de données. */
	resetDatabase = "calao-reset-database",
	/** Identifiant d'une entrée de log qui a échoué. */
	loggerAddEntryFailed = "logger-add-entry-failed",
	/** Identifiant de batterie faible de l'appareil. */
	lowDeviceBattery = "calao-device-battery-low",
	/** Identifiant de l'action de mise en arrière plan de l'application. */
	appSuspended = "calao-app-suspended",
	/** Identifiant de reprise d'activité de l'application. */
	appResumed = "calao-app-resumed",

	//#region Mise à jour

	/** Identifiant indiquant qu'une mise à jour de l'application est disponible. */
	updateAvailable = "calao-update-available",
	/** Identifiant de mise à jour refusée par l'utilisateur. */
	updateCanceled = "calao-update-canceled",
	/** Indentifiant de mise à jour installée par l'utilisateur. */
	updateSuccess = "calao-update-success",
	/** Identifiant d'échec lors du téléchargement ou de l'installation de la mise à jour. */
	updateFailed = "calao-update-failed",

	//#endregion

	//#region Pin

	/** Identifiant pour une tentative de déblocage par pin échouée. */
	unlockPinAttemptFailed = "calao-unlock-pin-attempt-failed"

	//#endregion
}
